var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenschool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1210 1210",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M747 296.22c126.59 56.4 155.43-77.62 155.43-77.62s-97.77 10.7-150.23-46.63c-87.46-95.53-155.36-46.61-155.36-46.61l2.61 189.03s59.2-57.53 147.55-18.17zm155.5 340.92 75.3 2.24-374.3-287.07L242.64 634.6l69.34 2.23 4.48 388.02H232.2v72.33h745.6v-72.33h-75.3ZM661.8 763c-22.97 59.36-75.06 108.36-128.93 125.42-18.04 39.8-2.34 140.6-2.34 140.6l-10.99 2.7c-25.65-57.13-28.23-137.2-28.49-154.4-26.48-40-78.62-139.86.2-244.1 51.03-65.8 121.5-80.45 148.84-130.49 49.6 64.24 48.69 189.87 21.71 260.27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M501.52 827.76c5.64 26.46 42.02 29 30.59-26.19-6.86-32.97 5.39-134.54 87.3-221.07-113.09 80.96-120.88 212.75-117.9 247.26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenschool);
export default __webpack_public_path__ + "static/media/Green school.61863fdb50bde808794c64bc4ff3f14f.svg";
export { ForwardRef as ReactComponent };